export const isDevEnv = process.env.REACT_APP_ENV === "development"

export const API_ENDPOINT = isDevEnv ? `http://localhost:5000` : `https://api.forgepad.finance`
export const FILE_ENDPOINT = `https://files.forgepad.finance/`

// export const IPFS_UPLOAD_URL = "https://api.pinata.cloud/pinning/pinFileToIPFS"
//export const IPFS_GATEWAY_URL = "https://coffee-magnetic-rattlesnake-502.mypinata.cloud/ipfs"

export const ETHISM_TELEGRAM_URL = "https://t.me/Ethismdotfun"
export const ETHISM_TWITTER_URL = "https://x.com/ethismfun"
export const ETHISM_WEBSITE_URL = "https://forgepad.finance"